import { GET_ENVIRONMENT, SET_TOKEN_DIFF } from "../constants/constants";

const initialState = { environment: "", SPK: "", token_diff: 0 };

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ENVIRONMENT:
      return {
        ...state,
        environment: action.environment.env.substring(0, 3),
        SPK: action.environment.hashP,
      };
    case SET_TOKEN_DIFF: {
      return {
        ...state,
        token_diff: action.token_diff,
      };
    }
    default:
      return state;
  }
};

export const getEnvironment = (state) => state.envReducer?.environment;
export const getSpk = (state) => state.envReducer?.SPK;
